import ITenantUser from '../model/ITenantUser'

export type LoadUsersType = {
  type: string
  tenantId: string
}
export const LOAD_USERS = 'USERS/LOAD'
export const loadUsers = (tenantId: string): LoadUsersType => ({
  type: LOAD_USERS,
  tenantId
})

export type DeleteUsersType = {
  type: string
  users: ITenantUser[]
  tenantId: string
}
export const DELETE_USERS = 'USERS/DELETE'
export const deleteUsers = (
  users: ITenantUser[],
  tenantId: string
): DeleteUsersType => ({
  type: DELETE_USERS,
  users,
  tenantId
})

export type UpdateUserType = {
  type: string
  user: ITenantUser
  tenantId: string
}
export const UPDATE_USER = 'USERS/UPDATE'
export const updateUser = (
  user: ITenantUser,
  tenantId: string
): UpdateUserType => ({
  type: UPDATE_USER,
  user,
  tenantId
})

export type InviteUserType = {
  type: string
  email: string
  role: string
  redirectUri: string
  tenantId: string
}
export const INVITE_USER = 'USERS/INVITE'
export const inviteUser = (
  email: string,
  role: string,
  redirectUri: string,
  tenantId: string
): InviteUserType => ({
  type: INVITE_USER,
  email,
  role,
  redirectUri,
  tenantId
})

export type InviteUserSuccessType = {
  type: string
  email: string
}
export const INVITE_USER_SUCCESS = 'USERS/INVITE_SUCCESS'
export const inviteUserSuccess = (email: string): InviteUserSuccessType => ({
  type: INVITE_USER_SUCCESS,
  email
})

export type InviteUserErrorType = {
  type: string
  error: any
}
export const INVITE_USER_ERROR = 'USERS/INVITE_ERROR'
export const inviteUserError = (error: any): InviteUserErrorType => ({
  type: INVITE_USER_ERROR,
  error
})

export type LoadMemberReportType = {
  type: string
  tenantId: string
  // Generate a new report even if this tab has one cached.
  refresh?: boolean
}
export const LOAD_MEMBER_REPORT = 'USERS/LOAD_MEMBER_REPORT'
export const loadMemberReport = (
  tenantId: string,
  refresh = false
): LoadMemberReportType => ({
  type: LOAD_MEMBER_REPORT,
  tenantId,
  refresh
})
